module.exports = __webpack_public_path__ + "d18d551c97ae196904cefd1ad27fdcea.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/jogo-do-bicho/minhas-apostas.png
// module id = 1041
// module chunks = 0